import React, { useState, useContext } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
// import IconButton from "@material-ui/core/IconButton";
import { Link } from "react-router-dom";
import useStyles from "./styles";
import Typography from "@components/Typography";
import NotificationHeaderBadge from "@features/Notifications/components/HeaderBadge";
import CustomContainer from "@components/Container";
import clsx from "clsx";
import { useUserState } from "@features/User/context";
import { __t } from "@core/translation/translation";
import UserDropdownMenu from "@features/User/components/UserDropdownMenu";
import { Paper, Popover } from "@material-ui/core";
import ThemeContext from "@context/ThemeContext";
import Button from "@components/Button";
import { useHistory, useParams } from "react-router-dom";

export default function Header(props) {
  const { menuItems, opanMenu, paddingLayout } = props;
  const history = useHistory().location.pathname;
  const classes = useStyles();
  const { authorized } = useUserState();
  const [state, setState] = useState({
    open: false,
    anchorEl: null,
    market: null,
  });
  const { toggleTheme } = useContext(ThemeContext);
  const handlePopoverOpen = (event, popoverId, url) => {
    setState((prevState) => ({
      ...prevState,
      openedPopoverId: popoverId,
      anchorEl: event.target,
      market: url,
    }));
  };
  const handlePopoverClose = () => {
    setState((prevState) => ({
      ...prevState,
      openedPopoverId: null,
      anchorEl: null,
    }));
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <CustomContainer
          maxWidth=""
          classes={clsx(classes.pageContentWrapper, {
            classOpanMenu: !!opanMenu,
            paddingLayout: !!paddingLayout,
          })}
        >
          <Toolbar variant="dense" className={classes.toolbar}>
            <div className={classes.grow}>
              {menuItems.map((item, index) => (
                <Link
                  key={item.id}
                  to={
                    item.path === "/marketOrder" ? "/marketOrder/buy" : history
                  }
                >
                  <Button
                    onClick={(e) => handlePopoverOpen(e, item.id, item.path)}
                    className={
                      state.market === "/marketOrder"
                        ? classes.marketStyle
                        : history !== "/marketOrder/buy"
                        ? classes.iconButton
                        : item.id === "1"
                        ? classes.marketStyle2
                        : classes.iconButton
                    }
                    aria-label={item.label}
                    color="inherit"
                  >
                    <span className={clsx(item.iconImage, classes.icon2)} />
                    <Typography
                      color={
                        state.openedPopoverId !== item.id
                          ? "secondary.main"
                          : state.market === "/marketOrder"
                          ? "secondary.main"
                          : "primary.main"
                      }
                      variant={"sm"}
                    >
                      {item.title}
                    </Typography>
                    <span
                      className={clsx(
                        state.openedPopoverId === item.id
                          ? item.closeIcon
                          : item.icon,
                        classes.icon
                      )}
                    />
                  </Button>
                  {item.icon?.length > 0 && item.id === index && (
                    <Popover
                      open={state.openedPopoverId === item.id}
                      anchorEl={state.anchorEl}
                      onClose={handlePopoverClose}
                      className={classes.popOverContainer}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                    >
                      <Paper className={classes.popOver} elevation={0}>
                        <item.popOverComponent
                          handlePopoverClose={handlePopoverClose}
                        />
                      </Paper>
                    </Popover>
                  )}
                </Link>
              ))}
            </div>
            <div className={classes.leftSection}>
              {(authorized && (
                <div className={classes.sectionDesktop}>
                  <span className={classes.changeTheme} onClick={toggleTheme}>
                    <i className="icon-sun" />
                  </span>
                  <div className={classes.question}>
                    <i className="icon-question" />
                  </div>
                  <NotificationHeaderBadge />
                  <UserDropdownMenu />
                </div>
              )) || (
                <>
                  <>
                    <Link to={"/register"}>
                      <Button variant={"contained"} color={"secondary.main"}>
                        {__t("signup")}
                      </Button>
                    </Link>
                    <Link to={"/login"}>
                      <Button variant={"outlined"} color={"secondary.main"}>
                        {__t("sign in")}
                      </Button>
                    </Link>
                  </>
                </>
              )}
            </div>
          </Toolbar>
        </CustomContainer>
      </AppBar>
    </div>
  );
}
